import React from 'react';
import '../../selections/selections.scss'
import { Button } from 'react-bootstrap';
import { Dropdown } from 'primereact/dropdown';
import { useHitTracking } from '../../../context/hit-tracking-context';

const PeriodSelection = (props) => { // props: {periods, activePeriod, clickPeriod}
    const { trackInteraction } = useHitTracking();

    const handlePeriodClick = (period) => {
        if (props.activePeriod !== period) {
            const periodName = period?.name || period?.code || period;
            trackInteraction(`period/${periodName}`);
        }

        props.clickPeriod?.(period);
    };

    return (
        <div className='time-period-box roboto-bold-14'>
            {props.dropdownPeriod &&
                <Dropdown placeholder={props.dropdownPeriodPlaceHolder} options={props.dropdownPeriod} optionLabel={props.dropdownOptionLabel} value={props.activePeriod} onChange={(e) => handlePeriodClick(e.value)}>
                </Dropdown>
            }

            {props.periods?.map((period, index) => {
                return (
                    <Button key={index} variant="" className={`title ${props.activePeriod === period ? 'active' : ''}`} onClick={() => handlePeriodClick(period)} >{period}</Button>
                )
            })}
        </div>
    )
}

export default PeriodSelection;
